<template>
  <InputHider :toggle-class="toggleClass" :save-handler="saveComment" :placeholder="'Pridaj komentár'" :points-gained="user ? commentPoints : 0">
    <ckeditor :editor="editor" v-model="commentText" :config="editorConfig"></ckeditor>
  </InputHider>

  <CommentWrapper
      :comments="comments"
      :toggle-class="toggleClass"
      :slice-comments="sliceComments"
      @delete-comment="deleteComment"
  />
</template>

<script>
import { getCommentsByProperty } from "../helpers/CommentApi";
import { createComment,  deleteComment } from "../helpers/CommentApi";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import { commentConfig } from "../ckeditor/configs";
import InputHider from "../InputHider/InputHider.vue";
import CommentWrapper from "../Comment/CommentWrapper.vue";

export default {
  name: "CommentEntityWrapper",
  components: { InputHider, CommentWrapper },
  emits: ['reload'],
  inject: ['user'],
  props: {
    entityId: String,
    toggleClass: String,
    fk_property: String,
    sliceComments: {
      type: Number,
      default: 1
    },
    commentPoints: Number,
  },
  data() {
    return {
      commentText: '',
      comments: [],
      editor: ClassicEditor,
      editorConfig: commentConfig
    }
  },
  methods: {
    saveComment() {
      let data = {
        text: this.commentText
      };

      data[this.fk_property] = this.entityId;

      const component = this;
      createComment(data).then(res => {
        this.$emit('reload');
        component.comments.push(res.data);
      });
      this.commentText = '';
    },
    deleteComment(id) {
      deleteComment(id).then(res => {
        this.$emit('reload');
        this.loadComments();
      });
    },
    loadComments() {
      getCommentsByProperty(this.fk_property, this.entityId).then(res => {
        this.comments = res.data;
      });
    }
  },
  mounted() {
    this.loadComments();
  }
}
</script>
